import { $ as e, F as t, G as n, L as r, g as i, i as a, k as o, p as s, v as c, w as l } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { t as u } from "./i18n-lite-BcmwMblk.js";
import { a as d, c as f, i as p, l as m, n as h, o as g, r as _, s as v, t as y, u as b } from "./image-quiz.ce-CbIXBCFS.js";
//#endregion
//#region src/webcomponents/image-quiz/ImageQuizzes.ce.vue
var x = /* @__PURE__ */ l({
	__name: "ImageQuizzes.ce",
	props: { quizzes: { type: Array } },
	emits: ["answer"],
	setup(a, { emit: l }) {
		let u = l, d = e(Array(a.quizzes.length).fill(void 0));
		n(() => {
			if (!d.value.some((e) => e == null)) {
				if (d.value.some((e) => e === "")) {
					u("answer", "");
					return;
				}
				u("answer", d.value.join(","));
			}
		});
		function f(e, t) {
			d.value[t] = e.answer;
		}
		return (e, n) => (t(!0), c(s, null, r(a.quizzes, (e, n) => (t(), i(h, o({ key: n }, { ref_for: !0 }, e, {
			"show-name": !0,
			onAnswer: (e) => f(e, n)
		}), null, 16, ["onAnswer"]))), 128));
	}
});
//#endregion
//#region src/webcomponents/image-quiz/image-quizzes.ce.js
u.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": b,
	"./locales/en.json": m,
	"./locales/es-419.json": f,
	"./locales/es.json": v,
	"./locales/fr-BE.json": g,
	"./locales/fr.json": d,
	"./locales/it.json": p,
	"./locales/nl.json": _
}));
var S = a(x, { configureApp(e) {
	u.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(u);
} });
S.prototype.normalizeProps = (e) => ({
	...e,
	quizzes: e.quizzes.map(y)
}), window.customElements.define("image-quizzes", S);
//#endregion
